import BaseStore from "@/v1/utils/BaseStore";

const initialState = {};
const store = new BaseStore("countries", initialState);

export default store.reducer();
